'use client';

import { Toolbar, toolbarTag } from '@ni/nimble-components/dist/esm/toolbar';
import { wrap } from '../utilities/react-wrapper';

export { toolbarTag };
export { type Toolbar };
export const NimbleToolbar = wrap(Toolbar);
